import{desc as o}from"./base.js";/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */let n;function c(e){return(r,t)=>o(r,t,{get(){return(this.renderRoot??n??(n=document.createDocumentFragment())).querySelectorAll(e)}})}export{c as queryAll};
